/**
 * Shared desktop/mobile labels for the three project-view tabs (Results, Excluded, Comments).
 * TD-2853: mobile labels are shortened so all three fit on a 375px screen; desktop keeps full text.
 *
 * @param {{ resultsCountLabel: string|number, excludedCount: number, teamCommentsCount: number }} counts
 * @returns {{ results: object, excluded: object, comments: object }} name/mobileName pairs per tab
 */
export const buildProjectViewTabLabels = ({
  resultsCountLabel,
  excludedCount,
  teamCommentsCount
}) => ({
  results: {
    name: `Search results (${resultsCountLabel})`,
    mobileName: `Results (${resultsCountLabel})`
  },
  excluded: {
    name: `Excluded results (${excludedCount})`,
    mobileName: `Excluded (${excludedCount})`
  },
  comments: {
    name: `Team comments (${teamCommentsCount})`,
    mobileName: `Comments (${teamCommentsCount})`
  }
});

/**
 * Renders the desktop/mobile label pair used by project tab strips.
 */
export const ProjectTabLabelText = ({ name, mobileName }) => (
  <>
    <div className="desktop-text">{name}</div>
    <div className="mobile-text">{mobileName || name}</div>
  </>
);
